module.exports = __webpack_public_path__ + "img/dive.3e93a385.png";